import { trpc } from '@/shared/api';

export const useAdminTaxInvoiceQuery = (orderId: string, enabled: boolean) =>
  trpc.taxInvoiceManagement.get.useQuery({ orderId }, { enabled });
